export default {
  siteId: "22",
  siteName: "se",
  site: "se",
  lang: "SE",
  langCode: "sv-SE",
  MediaType: "Stödda filtyper inkluderar JPEG, JPG, PNG eller MP4.",
  MediaReward:
    "Dela bilder eller videor för att låsa upp speciella belöningar.",
  RewardQa: "Besvara alla nedanstående frågor för extra belöningar.",
  MoreQa: "Klicka för att fylla i fler frågor.",
  RewardsToast: "Din belöning har framgångsrikt krediterats till ditt konto.",
  subscribe1:
    "Du har framgångsrikt avregistrerat dig från Cupshe SE:s marknadsföringsmeddelanden",
  subscribe2: "Menade du inte att avsluta prenumerationen?",
  subscribe3: "ÅTERPRENUMERERA",
  subscribe4:
    "Du har framgångsrikt prenumererat på Cupshe SE:s marknadsföringsmeddelanden.",
  "You're already on the list!": "Du är redan med på listan! :)",
  "Oops, there was a hiccup!Please try again.":
    "Hoppsan, det uppstod en hicka! Försök igen.",
  mailContact:
    'Vänligen kontakta <a href="https://se.cupshe.com/pages/contact-us" class="contact_link">kundtjänst</a> för hjälp.',
  policyText:
    "* Observera: När du har avslutat prenumerationen kan du få e-postmeddelanden som innehåller avtalsinformation om framtida onlineköp (orderbekräftelser, leveransmeddelanden, återbetalningsaviseringar etc.).",
};
